/**
 * om-wishlist.js
 * Wishlist store, header badge, and the /pages/wishlist renderer.
 *
 * Background: the header heart used to link to /apps/wishlist/wishlist, the
 * Swym Wishlist Plus app proxy. That app is gone and the proxy 404s. The card
 * hearts in om-card.js were saving product IDs to localStorage that nothing
 * ever read back, and the header badge was never fed at all. This file joins
 * those pieces into one system with no app dependency.
 */
(function () {
  'use strict';

  if (window.OMWishlist) return;

  var KEY = 'om-wishlist-items';
  var LEGACY_KEY = 'om-wishlist';
  var PAGE_URL = '/pages/wishlist';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function read() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw.filter(function (x) { return x && x.handle; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    try {
      window.localStorage.setItem(LEGACY_KEY, JSON.stringify(list.map(function (x) { return String(x.id); })));
    } catch (e) {}
    paintBadge();
  }

  function has(handle) { return read().some(function (x) { return x.handle === handle; }); }

  function add(id, handle) {
    if (!handle) return;
    var list = read();
    if (list.some(function (x) { return x.handle === handle; })) return;
    list.push({ id: String(id || ''), handle: handle, at: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
  }

  function esc(s) {
    if (s === null || s === undefined) return '';
    var out = String(s);
    out = out.split('&').join('&amp;');
    out = out.split('<').join('&lt;');
    out = out.split('>').join('&gt;');
    out = out.split(String.fromCharCode(34)).join('&quot;');
    out = out.split(String.fromCharCode(39)).join('&#39;');
    return out;
  }

  function paintBadge() {
    var n = read().length;
    var badges = document.querySelectorAll('[data-hc-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(n);
      if (n > 0) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
  }

  function fixHeaderLink() {
    var href = root().replace(/\/$/, '') + PAGE_URL;
    var links = document.querySelectorAll('[data-hc-wishlist-link]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') !== href) links[i].setAttribute('href', href);
    }
    var stale = document.querySelectorAll('a[href*="apps/wishlist"]');
    for (var j = 0; j < stale.length; j++) stale[j].setAttribute('href', href);
  }

  document.addEventListener('om:wishlist:toggled', function (e) {
    var d = e.detail || {};
    if (d.active) add(d.productId, d.productHandle);
    else remove(d.productHandle);
    renderPage();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { paintBadge(); renderPage(); }
  });

  var cache = {};

  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root() + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return 'Rs. ' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function sized(src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
  }

  function cardHTML(p, handle) {
    var variants = p.variants || [];
    var v = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available) { v = variants[i]; break; } }
    if (!v) v = variants[0];

    var multi = variants.length > 1;
    var url = root() + 'products/' + handle;
    var q = String.fromCharCode(34);

    var options = '';
    for (var k = 0; k < variants.length; k++) {
      var x = variants[k];
      options += '<option value=' + q + x.id + q + ' data-price=' + q + x.price + q +
        (x.available ? '' : ' disabled') +
        (v && x.id === v.id ? ' selected' : '') + '>' +
        esc(x.title) + (x.available ? '' : ' - sold out') + '</option>';
    }

    var media = p.featured_image
      ? '<img src=' + q + sized(p.featured_image, 500) + q + ' alt=' + q + esc(p.title) + q + ' loading=' + q + 'lazy' + q + ' width=' + q + '500' + q + ' height=' + q + '500' + q + '>'
      : '<span class=' + q + 'omw-card__ph' + q + '></span>';

    return '<li class=' + q + 'omw-card' + q + ' data-omw-item=' + q + esc(handle) + q + '>' +
        '<a class=' + q + 'omw-card__media' + q + ' href=' + q + url + q + '>' + media + '</a>' +
        '<button type=' + q + 'button' + q + ' class=' + q + 'omw-card__remove' + q +
          ' data-omw-remove=' + q + esc(handle) + q + ' aria-label=' + q + 'Remove from wishlist' + q + '>' +
          '<svg viewBox=' + q + '0 0 24 24' + q + ' aria-hidden=' + q + 'true' + q + '>' +
          '<path d=' + q + 'M6 6l12 12M18 6L6 18' + q + ' stroke=' + q + 'currentColor' + q +
          ' stroke-width=' + q + '2' + q + ' stroke-linecap=' + q + 'round' + q + '/></svg>' +
        '</button>' +
        '<div class=' + q + 'omw-card__body' + q + '>' +
          '<a class=' + q + 'omw-card__title' + q + ' href=' + q + url + q + '>' + esc(p.title) + '</a>' +
          '<p class=' + q + 'omw-card__price' + q + ' data-omw-price>' + (v ? money(v.price) : '') + '</p>' +
          (multi ? '<select class=' + q + 'omw-card__select' + q + ' data-omw-select aria-label=' + q + 'Choose size' + q + '>' + options + '</select>' : '') +
          '<button type=' + q + 'button' + q + ' class=' + q + 'omw-card__add' + q +
            ' data-omw-add=' + q + (v ? v.id : '') + q + (v && v.available ? '' : ' disabled') + '>' +
            (v && v.available ? 'Add to cart' : 'Sold out') +
          '</button>' +
        '</div>' +
      '</li>';
  }

  function renderPage() {
    var mount = document.querySelector('[data-omw-list]');
    if (!mount) return;

    var empty = document.querySelector('[data-omw-empty]');
    var countEl = document.querySelector('[data-omw-page-count]');
    var items = read();

    if (countEl) countEl.textContent = items.length ? items.length + (items.length === 1 ? ' item' : ' items') : '';

    if (!items.length) {
      mount.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');

    mount.setAttribute('aria-busy', 'true');

    Promise.all(items.map(function (it) {
      return getProduct(it.handle).then(function (p) { return p ? cardHTML(p, it.handle) : ''; });
    })).then(function (chunks) {
      mount.innerHTML = chunks.join('');
      mount.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-omw-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-omw-remove');
    remove(handle);
    var hearts = document.querySelectorAll('[data-om-wishlist]');
    for (var i = 0; i < hearts.length; i++) {
      if (hearts[i].getAttribute('data-product-handle') === handle) {
        hearts[i].classList.remove('is-active');
        hearts[i].setAttribute('aria-pressed', 'false');
      }
    }
    renderPage();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-omw-select]') : null;
    if (!sel) return;
    var card = sel.closest('.omw-card');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card.querySelector('[data-omw-price]');
    var addBtn = card.querySelector('[data-omw-add]');
    if (priceEl) priceEl.textContent = money(Number(opt.getAttribute('data-price')));
    if (addBtn) {
      addBtn.setAttribute('data-omw-add', opt.value);
      addBtn.disabled = opt.disabled;
      addBtn.textContent = opt.disabled ? 'Sold out' : 'Add to cart';
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-omw-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-omw-add');
    if (!id) return;

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding...';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) {
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = original; }, 2000);
          return;
        }
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('om:cart:added', { detail: res.data }));
        if (window.OMCart && typeof window.OMCart.refreshAndOpen === 'function') window.OMCart.refreshAndOpen();
        setTimeout(function () { btn.textContent = original; }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = original; }, 2000);
      });
  });

  function boot() {
    if (!window.localStorage.getItem(KEY)) {
      var legacy = [];
      try { legacy = JSON.parse(window.localStorage.getItem(LEGACY_KEY)) || []; } catch (e) {}
      if (legacy.length) {
        var recovered = [];
        var hearts = document.querySelectorAll('[data-om-wishlist]');
        for (var i = 0; i < legacy.length; i++) {
          for (var j = 0; j < hearts.length; j++) {
            if (hearts[j].getAttribute('data-product-id') === String(legacy[i])) {
              var h = hearts[j].getAttribute('data-product-handle');
              if (h) recovered.push({ id: String(legacy[i]), handle: h, at: Date.now() });
              break;
            }
          }
        }
        if (recovered.length) write(recovered);
      }
    }

    fixHeaderLink();
    paintBadge();
    renderPage();
  }

  window.OMWishlist = {
    all: read, add: add, remove: remove, has: has,
    count: function () { return read().length; },
    refresh: function () { paintBadge(); renderPage(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { fixHeaderLink(); paintBadge(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();